let wasm;

const heap = new Array(128).fill(undefined);

heap.push(undefined, null, true, false);

let heap_next = heap.length;

function addHeapObject(obj) {
    if (heap_next === heap.length) heap.push(heap.length + 1);
    const idx = heap_next;
    heap_next = heap[idx];

    heap[idx] = obj;
    return idx;
}

function getObject(idx) { return heap[idx]; }

function dropObject(idx) {
    if (idx < 132) return;
    heap[idx] = heap_next;
    heap_next = idx;
}

function takeObject(idx) {
    const ret = getObject(idx);
    dropObject(idx);
    return ret;
}

const cachedTextDecoder = (typeof TextDecoder !== 'undefined' ? new TextDecoder('utf-8', { ignoreBOM: true, fatal: true }) : { decode: () => { throw Error('TextDecoder not available') } } );

if (typeof TextDecoder !== 'undefined') { cachedTextDecoder.decode(); };

let cachedUint8Memory0 = null;

function getUint8Memory0() {
    if (cachedUint8Memory0 === null || cachedUint8Memory0.byteLength === 0) {
        cachedUint8Memory0 = new Uint8Array(wasm.memory.buffer);
    }
    return cachedUint8Memory0;
}

function getStringFromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    return cachedTextDecoder.decode(getUint8Memory0().subarray(ptr, ptr + len));
}
/**
*/
export function greet() {
    wasm.greet();
}

/**
* @returns {number}
*/
export function get_a_number() {
    const ret = wasm.get_a_number();
    return ret;
}

function _assertClass(instance, klass) {
    if (!(instance instanceof klass)) {
        throw new Error(`expected instance of ${klass.name}`);
    }
    return instance.ptr;
}
/**
* @param {DeadzoneModel} attacker
* @param {DeadzoneModel} defender
* @param {DeadzoneOptions} options
* @returns {Map<any, any>}
*/
export function deadzoneCalcDmgProbs(attacker, defender, options) {
    _assertClass(attacker, DeadzoneModel);
    _assertClass(defender, DeadzoneModel);
    _assertClass(options, DeadzoneOptions);
    const ret = wasm.deadzoneCalcDmgProbs(attacker.__wbg_ptr, defender.__wbg_ptr, options.__wbg_ptr);
    return takeObject(ret);
}

function handleError(f, args) {
    try {
        return f.apply(this, args);
    } catch (e) {
        wasm.__wbindgen_exn_store(addHeapObject(e));
    }
}
/**
*/
export class DeadzoneModel {

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;

        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_deadzonemodel_free(ptr);
    }
    /**
    * @returns {number}
    */
    get hp() {
        const ret = wasm.__wbg_get_deadzonemodel_hp(this.__wbg_ptr);
        return ret;
    }
    /**
    * @param {number} arg0
    */
    set hp(arg0) {
        wasm.__wbg_set_deadzonemodel_hp(this.__wbg_ptr, arg0);
    }
    /**
    * @returns {number}
    */
    get numDice() {
        const ret = wasm.__wbg_get_deadzonemodel_numDice(this.__wbg_ptr);
        return ret;
    }
    /**
    * @param {number} arg0
    */
    set numDice(arg0) {
        wasm.__wbg_set_deadzonemodel_numDice(this.__wbg_ptr, arg0);
    }
    /**
    * @returns {number}
    */
    get diceStat() {
        const ret = wasm.__wbg_get_deadzonemodel_diceStat(this.__wbg_ptr);
        return ret;
    }
    /**
    * @param {number} arg0
    */
    set diceStat(arg0) {
        wasm.__wbg_set_deadzonemodel_diceStat(this.__wbg_ptr, arg0);
    }
    /**
    * @returns {number}
    */
    get numRerolls() {
        const ret = wasm.__wbg_get_deadzonemodel_numRerolls(this.__wbg_ptr);
        return ret;
    }
    /**
    * @param {number} arg0
    */
    set numRerolls(arg0) {
        wasm.__wbg_set_deadzonemodel_numRerolls(this.__wbg_ptr, arg0);
    }
    /**
    * @returns {number}
    */
    get ap() {
        const ret = wasm.__wbg_get_deadzonemodel_ap(this.__wbg_ptr);
        return ret;
    }
    /**
    * @param {number} arg0
    */
    set ap(arg0) {
        wasm.__wbg_set_deadzonemodel_ap(this.__wbg_ptr, arg0);
    }
    /**
    * @returns {number}
    */
    get armor() {
        const ret = wasm.__wbg_get_deadzonemodel_armor(this.__wbg_ptr);
        return ret;
    }
    /**
    * @param {number} arg0
    */
    set armor(arg0) {
        wasm.__wbg_set_deadzonemodel_armor(this.__wbg_ptr, arg0);
    }
    /**
    * @returns {number}
    */
    get numShieldDice() {
        const ret = wasm.__wbg_get_deadzonemodel_numShieldDice(this.__wbg_ptr);
        return ret;
    }
    /**
    * @param {number} arg0
    */
    set numShieldDice(arg0) {
        wasm.__wbg_set_deadzonemodel_numShieldDice(this.__wbg_ptr, arg0);
    }
    /**
    * @returns {number}
    */
    get energyShields() {
        const ret = wasm.__wbg_get_deadzonemodel_energyShields(this.__wbg_ptr);
        return ret;
    }
    /**
    * @param {number} arg0
    */
    set energyShields(arg0) {
        wasm.__wbg_set_deadzonemodel_energyShields(this.__wbg_ptr, arg0);
    }
    /**
    * @returns {number}
    */
    get shieldDepleter() {
        const ret = wasm.__wbg_get_deadzonemodel_shieldDepleter(this.__wbg_ptr);
        return ret;
    }
    /**
    * @param {number} arg0
    */
    set shieldDepleter(arg0) {
        wasm.__wbg_set_deadzonemodel_shieldDepleter(this.__wbg_ptr, arg0);
    }
    /**
    * @returns {number}
    */
    get toxicDmg() {
        const ret = wasm.__wbg_get_deadzonemodel_toxicDmg(this.__wbg_ptr);
        return ret;
    }
    /**
    * @param {number} arg0
    */
    set toxicDmg(arg0) {
        wasm.__wbg_set_deadzonemodel_toxicDmg(this.__wbg_ptr, arg0);
    }
    /**
    * @returns {number}
    */
    get explodeStat() {
        const ret = wasm.__wbg_get_deadzonemodel_explodeStat(this.__wbg_ptr);
        return ret;
    }
    /**
    * @param {number} arg0
    */
    set explodeStat(arg0) {
        wasm.__wbg_set_deadzonemodel_explodeStat(this.__wbg_ptr, arg0);
    }
    /**
    * @returns {boolean}
    */
    get optics() {
        const ret = wasm.__wbg_get_deadzonemodel_optics(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
    * @param {boolean} arg0
    */
    set optics(arg0) {
        wasm.__wbg_set_deadzonemodel_optics(this.__wbg_ptr, arg0);
    }
    /**
    * @returns {boolean}
    */
    get sniperScope() {
        const ret = wasm.__wbg_get_deadzonemodel_sniperScope(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
    * @param {boolean} arg0
    */
    set sniperScope(arg0) {
        wasm.__wbg_set_deadzonemodel_sniperScope(this.__wbg_ptr, arg0);
    }
    /**
    * @returns {boolean}
    */
    get guarded() {
        const ret = wasm.__wbg_get_deadzonemodel_guarded(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
    * @param {boolean} arg0
    */
    set guarded(arg0) {
        wasm.__wbg_set_deadzonemodel_guarded(this.__wbg_ptr, arg0);
    }
    /**
    */
    constructor() {
        const ret = wasm.deadzonemodel_new();
        this.__wbg_ptr = ret >>> 0;
        return this;
    }
}
/**
*/
export class DeadzoneOptions {

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;

        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_deadzoneoptions_free(ptr);
    }
    /**
    * @returns {boolean}
    */
    get isHaloFlashpoint() {
        const ret = wasm.__wbg_get_deadzoneoptions_isHaloFlashpoint(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
    * @param {boolean} arg0
    */
    set isHaloFlashpoint(arg0) {
        wasm.__wbg_set_deadzoneoptions_isHaloFlashpoint(this.__wbg_ptr, arg0);
    }
    /**
    * @returns {number}
    */
    get numSimulations() {
        const ret = wasm.__wbg_get_deadzoneoptions_numSimulations(this.__wbg_ptr);
        return ret;
    }
    /**
    * @param {number} arg0
    */
    set numSimulations(arg0) {
        wasm.__wbg_set_deadzoneoptions_numSimulations(this.__wbg_ptr, arg0);
    }
    /**
    * @returns {number}
    */
    get numRounds() {
        const ret = wasm.__wbg_get_deadzoneoptions_numRounds(this.__wbg_ptr);
        return ret;
    }
    /**
    * @param {number} arg0
    */
    set numRounds(arg0) {
        wasm.__wbg_set_deadzoneoptions_numRounds(this.__wbg_ptr, arg0);
    }
    /**
    * @returns {boolean}
    */
    get attackerCanBeDamaged() {
        const ret = wasm.__wbg_get_deadzoneoptions_attackerCanBeDamaged(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
    * @param {boolean} arg0
    */
    set attackerCanBeDamaged(arg0) {
        wasm.__wbg_set_deadzoneoptions_attackerCanBeDamaged(this.__wbg_ptr, arg0);
    }
    /**
    * @returns {number}
    */
    get explodingDiceMaxLevels() {
        const ret = wasm.__wbg_get_deadzoneoptions_explodingDiceMaxLevels(this.__wbg_ptr);
        return ret;
    }
    /**
    * @param {number} arg0
    */
    set explodingDiceMaxLevels(arg0) {
        wasm.__wbg_set_deadzoneoptions_explodingDiceMaxLevels(this.__wbg_ptr, arg0);
    }
    /**
    */
    constructor() {
        const ret = wasm.deadzoneoptions_new();
        this.__wbg_ptr = ret >>> 0;
        return this;
    }
}

async function __wbg_load(module, imports) {
    if (typeof Response === 'function' && module instanceof Response) {
        if (typeof WebAssembly.instantiateStreaming === 'function') {
            try {
                return await WebAssembly.instantiateStreaming(module, imports);

            } catch (e) {
                if (module.headers.get('Content-Type') != 'application/wasm') {
                    console.warn("`WebAssembly.instantiateStreaming` failed because your server does not serve wasm with `application/wasm` MIME type. Falling back to `WebAssembly.instantiate` which is slower. Original error:\n", e);

                } else {
                    throw e;
                }
            }
        }

        const bytes = await module.arrayBuffer();
        return await WebAssembly.instantiate(bytes, imports);

    } else {
        const instance = await WebAssembly.instantiate(module, imports);

        if (instance instanceof WebAssembly.Instance) {
            return { instance, module };

        } else {
            return instance;
        }
    }
}

function __wbg_get_imports() {
    const imports = {};
    imports.wbg = {};
    imports.wbg.__wbg_alert_c6740fe207fe2531 = function(arg0, arg1) {
        alert(getStringFromWasm0(arg0, arg1));
    };
    imports.wbg.__wbindgen_number_new = function(arg0) {
        const ret = arg0;
        return addHeapObject(ret);
    };
    imports.wbg.__wbindgen_object_drop_ref = function(arg0) {
        takeObject(arg0);
    };
    imports.wbg.__wbg_crypto_58f13aa23ffcb166 = function(arg0) {
        const ret = getObject(arg0).crypto;
        return addHeapObject(ret);
    };
    imports.wbg.__wbindgen_is_object = function(arg0) {
        const val = getObject(arg0);
        const ret = typeof(val) === 'object' && val !== null;
        return ret;
    };
    imports.wbg.__wbg_process_5b786e71d465a513 = function(arg0) {
        const ret = getObject(arg0).process;
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_versions_c2ab80650590b6a2 = function(arg0) {
        const ret = getObject(arg0).versions;
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_node_523d7bd03ef69fba = function(arg0) {
        const ret = getObject(arg0).node;
        return addHeapObject(ret);
    };
    imports.wbg.__wbindgen_is_string = function(arg0) {
        const ret = typeof(getObject(arg0)) === 'string';
        return ret;
    };
    imports.wbg.__wbg_require_2784e593a4674877 = function() { return handleError(function () {
        const ret = module.require;
        return addHeapObject(ret);
    }, arguments) };
    imports.wbg.__wbindgen_is_function = function(arg0) {
        const ret = typeof(getObject(arg0)) === 'function';
        return ret;
    };
    imports.wbg.__wbindgen_string_new = function(arg0, arg1) {
        const ret = getStringFromWasm0(arg0, arg1);
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_msCrypto_abcb1295e768d1f2 = function(arg0) {
        const ret = getObject(arg0).msCrypto;
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_randomFillSync_a0d98aa11c81fe89 = function() { return handleError(function (arg0, arg1) {
        getObject(arg0).randomFillSync(takeObject(arg1));
    }, arguments) };
    imports.wbg.__wbg_getRandomValues_504510b5564925af = function() { return handleError(function (arg0, arg1) {
        getObject(arg0).getRandomValues(getObject(arg1));
    }, arguments) };
    imports.wbg.__wbindgen_object_clone_ref = function(arg0) {
        const ret = getObject(arg0);
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_call_90c26b09837aba1c = function() { return handleError(function (arg0, arg1) {
        const ret = getObject(arg0).call(getObject(arg1));
        return addHeapObject(ret);
    }, arguments) };
    imports.wbg.__wbg_new_bfd4534b584a9593 = function() {
        const ret = new Map();
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_set_d257c6f2da008627 = function(arg0, arg1, arg2) {
        const ret = getObject(arg0).set(getObject(arg1), getObject(arg2));
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_newnoargs_c62ea9419c21fbac = function(arg0, arg1) {
        const ret = new Function(getStringFromWasm0(arg0, arg1));
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_call_5da1969d7cd31ccd = function() { return handleError(function (arg0, arg1, arg2) {
        const ret = getObject(arg0).call(getObject(arg1), getObject(arg2));
        return addHeapObject(ret);
    }, arguments) };
    imports.wbg.__wbg_buffer_a448f833075b71ba = function(arg0) {
        const ret = getObject(arg0).buffer;
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_newwithbyteoffsetandlength_d0482f893617af71 = function(arg0, arg1, arg2) {
        const ret = new Uint8Array(getObject(arg0), arg1 >>> 0, arg2 >>> 0);
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_new_8f67e318f15d7254 = function(arg0) {
        const ret = new Uint8Array(getObject(arg0));
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_set_2357bf09366ee480 = function(arg0, arg1, arg2) {
        getObject(arg0).set(getObject(arg1), arg2 >>> 0);
    };
    imports.wbg.__wbg_newwithlength_6c2df9e2f3028c43 = function(arg0) {
        const ret = new Uint8Array(arg0 >>> 0);
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_subarray_2e940e41c0f5a1d9 = function(arg0, arg1, arg2) {
        const ret = getObject(arg0).subarray(arg1 >>> 0, arg2 >>> 0);
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_self_f0e34d89f33b99fd = function() { return handleError(function () {
        const ret = self.self;
        return addHeapObject(ret);
    }, arguments) };
    imports.wbg.__wbg_window_d3b084224f4774d7 = function() { return handleError(function () {
        const ret = window.window;
        return addHeapObject(ret);
    }, arguments) };
    imports.wbg.__wbg_globalThis_9caa27ff917c6860 = function() { return handleError(function () {
        const ret = globalThis.globalThis;
        return addHeapObject(ret);
    }, arguments) };
    imports.wbg.__wbg_global_35dfdd59a4da3e74 = function() { return handleError(function () {
        const ret = global.global;
        return addHeapObject(ret);
    }, arguments) };
    imports.wbg.__wbindgen_is_undefined = function(arg0) {
        const ret = getObject(arg0) === undefined;
        return ret;
    };
    imports.wbg.__wbindgen_memory = function() {
        const ret = wasm.memory;
        return addHeapObject(ret);
    };
    imports.wbg.__wbindgen_throw = function(arg0, arg1) {
        throw new Error(getStringFromWasm0(arg0, arg1));
    };

    return imports;
}

function __wbg_init_memory(imports, maybe_memory) {

}

function __wbg_finalize_init(instance, module) {
    wasm = instance.exports;
    __wbg_init.__wbindgen_wasm_module = module;
    cachedUint8Memory0 = null;


    return wasm;
}

function initSync(module) {
    if (wasm !== undefined) return wasm;

    const imports = __wbg_get_imports();

    __wbg_init_memory(imports);

    if (!(module instanceof WebAssembly.Module)) {
        module = new WebAssembly.Module(module);
    }

    const instance = new WebAssembly.Instance(module, imports);

    return __wbg_finalize_init(instance, module);
}

async function __wbg_init(input) {
    if (wasm !== undefined) return wasm;

    if (typeof input === 'undefined') {
        input = new URL('dice_sim_bg.wasm', import.meta.url);
    }
    const imports = __wbg_get_imports();

    if (typeof input === 'string' || (typeof Request === 'function' && input instanceof Request) || (typeof URL === 'function' && input instanceof URL)) {
        input = fetch(input);
    }

    __wbg_init_memory(imports);

    const { instance, module } = await __wbg_load(await input, imports);

    return __wbg_finalize_init(instance, module);
}

export { initSync }
export default __wbg_init;
